<template>
  <div>
    <v-container
      fluid
      class="ma-0 pa-0 mb-16 jumbo-header"
      style="min-height: 370px; line-height: 1.2 !important; background-color: #F9F9F9;"
    >
      <v-row justify="center" align="center" class="fill-height">
        <v-col class="pt-8 pb-16">
          <v-container>
            <back-button
              class="my-8"
              @click.native="$router.go(-1)"
            ></back-button>
            <v-row>
              <v-col cols="12" lg="10">
                <h2 class="home-header-2">
                  Thank you, based on your selection you are eligible to book.
                </h2>

                <div v-if="this.getSelectedBookingTypesGroup === bookingTypes.PERTUSSIS_CODE">
                  <br /><br />
                  <p class="mb-4 home-header-3">
                    Please note that if you have received any tetanus containing vaccine during this pregnancy you may already be protected against pertussis if it was administered when you were over 16 weeks pregnant.
                  </p>
                  <p class="mb-4 home-header-3">
                    If you received a Pertussis vaccine or any other tetanus containing vaccine prior to 16 weeks, please wait at least 4 weeks before proceeding with the pertussis vaccine.
                  </p>
                  <p class="mb-4 home-header-3">
                    Please discuss this with your midwife or GP.
                  </p>
                  <p class="mb-4 home-header-3">
                    If you require any further information please contact <a href="mailto:pha.immunisation@hscni.net">pha.immunisation@hscni.net</a>.
                  </p>
                </div>

                <div v-if="this.getSelectedBookingTypesGroup === bookingTypes.MENB_CODE">
                  <br /><br />
                  <p class="mb-4 home-header-3">
                    Unless your date of birth is between 02/07/2007 and 01/07/2008 inclusive, you will need to provide evidence of your conditional/unconditional offer of a place for the 2026/2027 academic year at your chosen university or college, otherwise, you risk not receiving your vaccination.
                  </p>
                  <p class="mb-4 home-header-3">
                    The relevant evidence can be an official email or letter or a screenshot from UCAS Hub providing confirmation of the offer of a place including the name of the university or college you are due to attend, the course code and/or title of the course of study.
                  </p>
                  <p class="mb-4 home-header-3">
                    Further information is available on
                    <a href="https://www.nidirect.gov.uk/articles/urgent-menb-vaccination-programme-adolescents-and-young-people" target="_blank">Urgent MenB vaccination programme for adolescents and young people | nidirect</a>.
                  </p>
                  <p class="mb-4 home-header-3">
                    We now need to verify your contact details. Please have your mobile number or email address ready.
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <div v-if="!accessToken">
        <p class="mb-2 home-text-2">
          We now need to verify your contact details.
        </p>
        <p class="mb-12 home-text-2">
          Please have your mobile number or email address ready.
        </p>
      </div>
      <v-btn @click="onAfterContinueClicked" class="v-btn--primary">
        Continue
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import auth from '@/helpers/auth';
import config from '@/config';
import Vue from 'vue';
import BackButton from '@/components/BackButton';
import { mapGetters } from 'vuex';
import { BookingTypes as bookingTypes } from "@/data/booking-types";

export default Vue.extend({
  components: {
    BackButton
  },
  name: 'StepEligible',
  data: () => ({
    ifEligible: null,
    bookingTypes: bookingTypes
  }),
  computed: {
    accessToken() {
      if (!auth.verifySavedToken()) {
        return false;
      }
      return localStorage.getItem(config.authTokenName);
    },
    ...mapGetters([
        'getFlowName',
        'getSelectedBookingTypesGroup'
    ])
  },
  methods: {
    onAfterContinueClicked() {
      this.$emit('ifEligible', true);

      if (this.accessToken) {
        this.$router.push('/booking/auth').catch(() => {});
      } else {
        this.$router.push('/booking/contact-details').catch(() => {});
      }
    },
    mounted(){
      this.$gtag.event(`Patient eligible to book` + `${this.getFlowName}`, {})
    }
  }
});
</script>
